import ReferenceCard from './reference-card';

export default class ReferenceCardDesktop extends ReferenceCard {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/reference-card/reference-card.desktop.js